import { render, staticRenderFns } from "./HUDForestTrees.vue?vue&type=template&id=795bff16&scoped=true&"
import script from "./HUDForestTrees.vue?vue&type=script&lang=ts&"
export * from "./HUDForestTrees.vue?vue&type=script&lang=ts&"
import style0 from "./HUDForestTrees.vue?vue&type=style&index=0&id=795bff16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795bff16",
  null
  
)

export default component.exports